import bin from './bin.js'
import layout from './layout.js'
import login from './login.js'
import shipments from './shipments.js'
import fleet from './fleet.js'
import register from './register.js'
import validation from './validation.js'
import profile from './profile.js'
import chat from './chat.js'
import settings from './settings.js'
import states from './states.js'
import offer from './offer.js'
import cars from './cars.js'
import dates from './dates.js'

const nl = Object.assign({}, layout.nl, login.nl, shipments.nl, fleet.nl, register.nl, validation.nl, profile.nl, chat.nl, settings.nl, bin.nl, states.nl, offer.nl, cars.nl, dates.nl)
const en = Object.assign({}, layout.en, login.en, shipments.en, fleet.en, register.en, validation.en, profile.en, chat.en, settings.en, bin.en, states.en, offer.en, cars.en, dates.en)
const fr = Object.assign({}, layout.fr, login.fr, shipments.fr, fleet.fr, register.fr, validation.fr, profile.fr, chat.fr, settings.fr, bin.fr, states.fr, offer.fr, cars.fr, dates.fr)

export default { nl: nl, en: en, fr: fr}